/**
 * @file: DefectiveLevel.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum DefectiveLevel {
  Normal = 'normal',
  Urgent = 'urgent',
  Warning = 'warning',
  Slight = 'slight',
}

export const DefectiveLevelValueSet = new Set([
  DefectiveLevel.Normal,
  DefectiveLevel.Urgent,
  DefectiveLevel.Warning,
  DefectiveLevel.Slight,
]);
